<template>
<div>

  <div class="header-banner">
    <section class="section header-block">
        <div class="container">
            <h1>Director submissions</h1>
        </div>
    </section>
  </div>

  <section class="section">
  <div class="container">
    <div class="content">

      <div class="columns">
        
        <div class="column is-two-thirds">
          <h1>Are you a director?</h1>

          <p>We’d love to hear from you. We are always open to director submissions.</p>

          <p>If you have a play that you’d like to direct or have other matters to discuss, please complete the form below or contact our Secretary: secretary@combinedactors.org</p>

          <form class="contact-form" id="contact-form" v-model="valid" ref="form" lazy-validation v-on:submit.prevent>
            <input type="hidden" name="_token" value="fasdghgfhshh" />

            <div class="field">
              <label class="label">Your name *</label>
                <div class="control">
                  <input autofocus :disabled="form.disabled" name="name" v-model.trim="form.name" v-validate="'required|min:3'" v-bind:class="{'is-danger': errors.has('name')}" class="input" type="text" placeholder="Your name">
                </div>
                <p class="help is-danger" v-show="errors.has('name')">
                  {{ errors.first('name') }}
                </p>
            </div>

            <div class="field">
              <label class="label">Your email *</label>
              <div class="control"> <!-- has-icons-left has-icons-right"> -->
                <input :disabled="form.disabled" name="email" v-model.trim="form.email" v-validate="'required|email'" v-bind:class="{'is-danger': errors.has('email')}" class="input" type="email" placeholder="example@email.com">
              </div>
              <p class="help is-danger" v-show="errors.has('email')">
                {{ errors.first('email') }}
              </p>
            </div>

            <div class="field">
              <label class="label">Subject</label>
                <div class="control">
                  <input name="subject" :disabled="form.disabled" v-model.trim="form.subject" v-bind:class="{'is-danger': errors.has('subject')}" class="input" type="text" placeholder="Subject of your message">
                </div>
                <p class="help is-danger" v-show="errors.has('subject')">
                  {{ errors.first('subject') }}
                </p>
            </div>

            <div class="field">
              <label class="label">Message</label>
              <div class="control">
                <textarea name="message" :disabled="form.disabled" class="textarea" placeholder="Type your message in here" v-bind:class="{'is-danger': errors.has('message')}" v-model="form.message"></textarea>
              </div>
              <p class="help is-danger" v-show="errors.has('message')">
                {{ errors.first('message') }}
              </p>
            </div>

            <div class="field is-grouped">
              <div class="control">
              </div>
            </div>

            <div class="field">
              <div class="control">
                <button class="button is-primary" :class="{'is-loading': form.sendingemail}" v-bind:disabled="errors.any() || form.disabled" @click="submit">{{ form.submitbuttoncopy }}</button>
              </div>
            </div>

          </form>

        </div>

      </div>
    </div>
  </div>
  </section>
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Api from '@/config/Api'

export default {
    // props: ['preselectSubject'],
    props: {
      preselectSubject: {
        default: '',
        type: String
      }
    }, 
    data() {
      return {
        form: {
          name: "",
          email: "",
          message: "",
          subject: "", 
          disabled: false,
          sendingemail: false,
          submitbuttoncopy: "Send message"
        },
        valid: true
      }
    },
    computed: {
        ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
        ...mapState({
          authLoading: state => state.status === 'loading',
          name: state => `${state.user.profile.name}`, 
        }),
    },
    created: function() {
      this.form.subject = this.preselectSubject;
      this.$store.commit('setContentLoaded', true); // then footer will be displayed
    },
    methods: {
      submit(evt) {
        evt.preventDefault()

        //Disable form...
        this.form.disabled = true;
        this.form.sendingemail = true; //show feedback spinner in button

        const { name, email, message, subject } = this.form

        var options = {
          name,
          email,
          message,
          subject,
          messagetype: "Director submission"
        }
        //console.log("options:",options)

        Api().post(`/api/sendemail/`, options)
        .then(response => {
          //console.log("response:",response.data);
          this.$swal('Message sent!', "We'll review your message and get back to you", 'success');  
          this.form.sendingemail = false; //stop feedback spinner in button   
          this.form.submitbuttoncopy = "Message sent";  
        })
        .catch((error) => {
          /* console.log("errorrrrRR:",error);
          console.log("errorrrrRR:",error.response); */
          const message = error.response.data.message; // || error.response.data;
          if (message) {
            this.$swal('Oh oo!', `${message}`, 'error');
          } else {
            this.$swal('Uh oh!', "We couldn't send your message for some reason. Please email: secretary@combinedactors.org", 'error');
          }
          this.form.sendingemail = false; //stop feedback spinner in button  
          this.form.disabled = false;

        });

      }

    },
    metaInfo: {
      title: "Director submissions",
      // titleTemplate: null // override the parent template and just use the above title only
      
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Directorsubmissions.vue